import { darken } from 'polished';
import styled, { css } from 'styled-components';
import { Colors } from './Colors';
import { toRem } from './Utils';

export type BadgeButtonProps = { color: string, size?: string | number, active?: boolean };

export const BadgeButton = styled.div<BadgeButtonProps>`
    position: relative;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    gap: 0.25rem;
    background: ${p => p.color};
    color: ${p => Colors.contrastTextColorFor(p.color)};
    font-weight: 500;
    font-size: ${p => toRem(p.size ?? 0.8125)};
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
    user-select: none;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
        background: ${p => darken(0.05, p.color)};
    }
    &:active {
        background: ${p => darken(0.1, p.color)};
    }
    ${p => p.active && css`
        background: ${darken(0.1, p.color)} !important;
    `}
`;
